import { Tournament } from 'src/services/tournaments/getTournaments';

export const tournamentDateComparator = (a: string, b: string): number => {
  const dateA = new Date(a);
  const dateB = new Date(b);

  if (a === 'null' || a === null) return 1;
  if (b === 'null' || b === null) return -1;

  if (dateA < dateB) {
    return -1;
  }
  if (dateA > dateB) {
    return 1;
  }

  return 0;
};
